import { defineComponent } from 'vue';
export default defineComponent({
  name: 'CommonHead',
  props: {
    to: {
      type: String,
      default: ''
    },
    // head title
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    showRedStar: {
      type: Boolean,
      default: false
    },
    // 是否展示下边框
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});